/**
 * Google Calendar public ICS subscribe: Apple uses webcal, others use Google Calendar web UI.
 */
function getCalendarSubscribeUrl(calendarId) {
    var encodedId = encodeURIComponent(calendarId);
    var icsHostPath = "calendar.google.com/calendar/ical/".concat(encodedId, "/public/basic.ics");
    var isApple = /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent);
    if (isApple) {
        return "webcal://".concat(icsHostPath);
    }
    return "https://calendar.google.com/calendar/render?cid=".concat(encodedId);
}
export function initCalendarSubscribe() {
    document.addEventListener('click', function (event) {
        var el = event.target;
        if (!(el instanceof Element)) {
            return;
        }
        var anchor = el.closest('a[data-cowp-calendar-subscribe]');
        if (!anchor || !(anchor instanceof HTMLAnchorElement)) {
            return;
        }
        var calId = anchor.getAttribute('data-calendar-id');
        if (!(calId === null || calId === void 0 ? void 0 : calId.trim())) {
            return;
        }
        event.preventDefault();
        window.location.assign(getCalendarSubscribeUrl(calId));
    });
}
